import DeviceData from 'drivers/deviceData';
import { translate as t } from 'utils/i18n';
import environment from 'utils/environment'

export function getSourceLabel(type, number) {
  var normalizedType = String(type || '').toUpperCase();
  if (normalizedType === 'HDMI') {
    return t('Source.hdmi_label').replace('{number}', String(number));
  }
  if (normalizedType === 'USB') {
    return t('Source.usb');
  }
  if (normalizedType === 'AV') {
    return t('Source.av');
  }
  return normalizedType + (number > 1 ? ' ' + number : '');
}

/**
 * @param {{ type: string, number: number }[]} inputs
 * @returns {{ id: string, label: string, sourceType: string, number: number }[]}
 */
export function mapSourcesToSettingsItems(inputs) {
  if (!inputs || !inputs.length) {
    return [];
  }

  return inputs.map(function (input) {
    return {
      id: String(input.type).toLowerCase() + '-' + input.number,
      label: getSourceLabel(input.type, input.number),
      sourceType: input.type,
      number: input.number,
    };
  });
}

/** @deprecated Use mapSourcesToSettingsItems */
export function mapHdmiPortsToSettingsItems(inputs) {
  return mapSourcesToSettingsItems(inputs);
}

export async function loadHdmiPortsForSettings() {
  try {
    var inputs = await DeviceData.getHdmiInputs();
    return mapSourcesToSettingsItems(inputs);
  } catch (error) {
    console.log('[hdmi] loadHdmiPortsForSettings failed: ' + (error.message || error));
    return [];
  }
}

export function getHdmiSettingsCategory() {
  return {
    id: 'source',
    label: t('Source.settings_category'),
  };
}

export async function addHdmiSourceChangeListener(callback) {
  try {
    return await DeviceData.addHdmiSourceChangeListener(callback)
  } catch (error) {
    console.log('[hdmi]-', "failed while adding listner-",error.message || error)
  }
}
export async function removeHdmiSourceChangeListner() {
  try {
    return await DeviceData.removeHdmiSourceChangeListener()
  } catch (error) {
    console.log('[hdmi]-', "failed while removing listner-",error.message || error)
  }
}
export async function getHdmiCastingDevices() {
  if (!environment.isCastingEnabled()) return []
  const devices= await loadHdmiPortsForSettings()
  return devices.filter(d=>d.sourceType=='HDMI')
}

export function buildSourceRoutePath(sourceType, number) {
  return '/source/' + String(sourceType).toLowerCase() + '/' + number;
}
